import { Text } from "@frends/ui-components/react";

export default Text;
